












































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TextInput, Uploader, PickerInput } from '@/components';
import { Button, Dialog, Toast, Popup } from 'vant';
import { FileType } from '@/common/ts/enum';
import { save } from './api/api';
import * as config from './config';

Vue.use(Toast)
  .use(Popup)
  .use(Dialog)
  .use(Button);
@Component({
  components: {
    TextInput,
    Uploader,
    PickerInput,
  },
})
export default class Register extends Vue {
  options = config.OPTHINES;
  pointOut = false;
  noButton = true;
  FileType = FileType;
  // 需要传的参数
  name: string = ''; // 姓名
  job: string = ''; // 职务
  content?: string = ''; // 个人简介
  certificate?: any[] = []; // 从业资格证书图
  image?: any[] = []; // 照片
  phone?: string = ''; // 联系电话
  getOssCertificateImagesUrls(result: any) {
    this.certificate = result[0];
  }
  getOssImagesUrls(result: any) {
    this.image = result[0];
  }
  enterSave() {
    if (!this.name) {
      Toast.fail('请填写姓名');
      return false;
    }
    if (!this.job) {
      Toast.fail('请填写职务');
      return false;
    }
    if (!this.phone) {
      Toast.fail('请填写手机号码');
      return false;
    } else {
      const mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(199[0-9]{8})$/;
      if (!mobile.test(this.phone)) {
        Toast.fail('请输入正确手机号码');
        return false;
      }
    }
    if (this.image && this.image.length <= 0) {
      Toast.fail('请上传照片');
      return false;
    }
    if (!this.content) {
      Toast.fail('请填写个人简介');
      return false;
    }
    save(this.options.voteName, {
      name: this.name,
      phone: this.phone,
      job: this.job,
      cover: this.image,
      certificate: this.certificate,
      content: this.content,
    }).then((res: any) => this.successSave(res));
  }
  successSave(res: any) {
    if (res.code === 500) {
      Toast.fail('信息填写不全！');
    } else if (res.code === 200) {
      Toast.success('提交成功，请等待审核！');
      this.noButton = false;
      setTimeout(() => {
        this.$router.go(0);
      }, 3000);
    } else {
      Toast('未知错误请联系后台');
    }
  }
}
